import styled from '@emotion/styled';

export const Indent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-left: 16px;
`;
